import { useEffect, useState } from "react";
import { z } from "zod";
import { ApiError, apiRequest } from "../../shared/api/client";

const accessSessionSchema = z.object({ role: z.string().min(1), permissions: z.array(z.string()) });
type AccessState = "loading" | "sign-in" | "denied" | "unavailable" | "allowed";

export function useGeneralProductionAccess() {
  const [state, setState] = useState<AccessState>("loading");
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    setState("loading");
    void apiRequest<unknown>("/api/session", { cache: "no-store", signal: controller.signal })
      .then((response) => {
        const session = accessSessionSchema.parse(response);
        if (!active) return;
        setState(session.role === "GUEST" ? "sign-in"
          : session.permissions.includes("production.report.read") ? "allowed" : "denied");
      })
      .catch((error: unknown) => {
        if (!active) return;
        setState(error instanceof ApiError && error.code === "HTTP_401" ? "sign-in"
          : error instanceof ApiError && error.code === "HTTP_403" ? "denied" : "unavailable");
      });
    return () => { active = false; controller.abort(); };
  }, [attempt]);
  return { state, retry: () => setAttempt((current) => current + 1) };
}
